import { Avatar, Card, Heading } from '@lmc/ui-kit'
import { User } from '@lmc/ts-common'
import styled from 'styled-components'
import { BackButton, Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { teamTranslations } from 'locale/team'
import { history } from 'store'

type TeamMemberSideNavigationProps = {
  carer: User
}

const TeamMemberSideNavigationCard = ({
  carer,
}: TeamMemberSideNavigationProps) => {
  const { t } = useTranslation(NAMESPACE.TEAM)

  return (
    <Card>
      <BackButton onClick={() => history.push('/organisation/list')}>
        {t(teamTranslations.TEAM_MEMBERS_LIST)}
      </BackButton>
      <TeamMemberInfoWrapper>
        <Avatar size={48} url={carer.picture as unknown as string} />
        <TextWrapper>
          <CarerName level={4}>
            {carer.name?.first} {carer.name?.last}
          </CarerName>
          <CarerRole>{t(teamTranslations[carer.role])}</CarerRole>
          {carer.active ? (
            <CarerStatus $active level={2}>
              {t(teamTranslations.ACTIVE)}
            </CarerStatus>
          ) : (
            <CarerStatus level={2}>{t(teamTranslations.INACTIVE)}</CarerStatus>
          )}
        </TextWrapper>
      </TeamMemberInfoWrapper>
    </Card>
  )
}

const CarerName = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color1};
`

const CarerRole = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
`

const CarerStatus = styled(Text)<{ $active?: boolean }>`
  color: ${(props) =>
    props?.$active
      ? props.theme.color.status.success
      : props.theme.color.status.danger};
`

const TeamMemberInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export default TeamMemberSideNavigationCard
